import { Box, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useResponsiveBreakpoints } from "src/utils/useResponsiveBreakpoints";

export type ReferenceBoxProps = {
    name: string | undefined;
};

export const ReferenceBox = (props: ReferenceBoxProps) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { isMobile } = useResponsiveBreakpoints();

    if (!props.name) return null;

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: theme.palette.background.paper,
                width: "fit-content",
                padding: theme.spacing(1),
                borderRadius: "6px",
                gap: theme.spacing(1),
                border: `1px solid ${theme.palette.grey[500]}`,
            }}
        >
            <Typography variant="h5">{t("reference")}:</Typography>
            <Typography variant="body-medium">{props.name}</Typography>
        </Box>
    );
};
